/**
 * @description Форматирование цены
 * @param price
 * @example 9990 -> 9 990
 */
export const formatPrice = (price: number | string) => {
  return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}
